module.exports = __webpack_public_path__ + "img/no-signature.1705886.svg";